import { render, staticRenderFns } from "./detail-sio-vendor.vue?vue&type=template&id=1a652ae6&"
import script from "./detail-sio-vendor.vue?vue&type=script&lang=js&"
export * from "./detail-sio-vendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports